import { PAYMENT_STATUS } from '../types/payout.types';
import { PRIZE_TYPE } from '../constants/sort';
import { Winning } from '../types/prize.types';
import { StepComponentProps } from '../components/prizes/PrizeStep';

export const isPrizeClaimed = (winning?: Winning): boolean => {
    return Boolean(
        winning?.paymentStatus === PAYMENT_STATUS.COMPLETED || winning?.markedOfflinePay
    );
};

export const isPrizeOffline = (winning?: Winning, isPrizeOffline?: boolean): boolean => {
    return Boolean(winning?.eventOfflinePaymentMarked || isPrizeOffline);
};

export const isPrizeCash = (winning?: Winning): boolean => {
    return winning?.prizeType === PRIZE_TYPE.CASH;
};

export const isFRMinorPrize = (winning: Winning, isOfflinePayment: boolean): boolean => {
    // If the user data is an online event, but the payment is made offline, it means the user can only be a FR minor.
    return !winning?.eventOfflinePaymentMarked && isOfflinePayment;
};

export interface StepPropsOptions {
    step: number;
    currentStep: number;
    winning?: Winning;
    isCash?: boolean;
    isOffline?: boolean;
    identityTaxVerified: boolean;
    goToNextStep: () => void;
    goToPreviousStep: () => void;
    getStepStatus: (stepIndex: number) => any;
    isStepCompleted: (stepIndex: number) => boolean;
}

export interface EnhancedStepPropsOptions extends StepPropsOptions {
    additionalProps?: Record<string, any>;
}

export const getStepProps = (options: StepPropsOptions): StepComponentProps => {
    const {
        step,
        currentStep,
        winning,
        isCash,
        isOffline,
        identityTaxVerified,
        goToNextStep,
        goToPreviousStep,
        getStepStatus,
        isStepCompleted
    } = options;

    return {
        onNext: goToNextStep,
        onPrevious: goToPreviousStep,
        canGoNext: step < currentStep,
        canGoPrevious: step > 1,
        winning,
        status: getStepStatus(step),
        isCash,
        offlinePayment: isOffline,
        identityTaxVerified,
        isCompleted: isStepCompleted(step)
    };
};

export const getEnhancedStepProps = (
    options: EnhancedStepPropsOptions
): StepComponentProps & Record<string, any> => {
    const baseProps = getStepProps(options);
    const { additionalProps = {} } = options;

    return {
        ...baseProps,
        ...additionalProps
    };
};
